// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--DTDsT6QOnFIrVYMZ"};